import useRidesStore from '../stores/rides'

const useRidesKeys = () => {
  const { page, per_page, search, from_datetime, to_datetime } = useRidesStore(state => state.searchOptions)

  return ['rides', page, per_page, search, to_datetime, from_datetime]
}

export default useRidesKeys

